/**
 * URL Constants for TuTiMi Application
 * Centralized location for all URLs, links, and external resources
 */

// ===== INTERNAL ROUTES =====
export const ROUTES = {
  HOME: "/",
  KHONG_GIAN: "/dia-diem",
  STORE_LOCATOR: "/cua-hang",
  ABOUT: "/thien-truc-breath",
  MENU: "/menu",
  THUC_DON_TAN_DINH: "/thuc-don-tan-dinh",
  THUC_DON_THU_DUC: "/thuc-don-thu-duc",
  PARTNER: "/partner",
  CONTACT: "/contact",
  POLICY: "/policy",
  // Platform tracking routes (redirect to home with cookie)
  ORDER: "/order", // Facebook tracking
  RESERVATION: "/tt", // TikTok tracking
  NOT_FOUND: "*",
} as const

export const SOCIAL_MEDIA = {
  FACEBOOK: {
    PAGE: "https://www.facebook.com/trasuatutimi?locale=vi_VN",
    RECRUITMENT: "https://www.facebook.com/tutimituyendung",
    EMBED:
      "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftrasuatutimi&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
  },
  TIKTOK: "https://www.tiktok.com/@trasua.tutimi?_t=8l6JjVpehR1&_r=1",
} as const

export const WEBSITE = {
  DOMAIN: "https://thientruc.com",
  TITLE: "Thiền Trúc",
  DESCRIPTION:
    "Khám phá lối sống lành mạnh cùng Thiền Trúc: thức uống thảo mộc, trà và cà phê nguyên bản. Mỗi giọt hạnh phúc, mỗi ly kết nối.",
  KEYWORDS:
    "Thiền Trúc, thiền trúc, trà, cà phê, thảo mộc, đồ uống lành mạnh, organic drinks, healthy drinks, Vietnamese tea",
  AUTHOR: "@thientruc",
} as const

// ===== ASSETS PATHS =====
export const ASSETS = {
  LOGOS: {
    MAIN: "/logos/logo.png",
    HEADER: "/logos/logo-header.png",
  },
  PRODUCTS: {
    FEATURED_DRINK: "/products/SUA-TUOI-MATCHA-DUONG-DEN-3-600x600.png",
  },
} as const

// ===== EXTERNAL LINKS =====
export const EXTERNAL_LINKS = {
  ORDER_NOW: SOCIAL_MEDIA.FACEBOOK.PAGE,
} as const

// ===== HELPER FUNCTIONS =====
// No helper functions needed for simplified routing

// ===== TYPE EXPORTS =====
export type RouteKey = keyof typeof ROUTES
export type SocialMediaKey = keyof typeof SOCIAL_MEDIA
